/**
 * @file: 流动边框线算法
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../../config/index';

export interface FlowBorderData {
    width: number,
    speed: number,
    space: number
}
export function getFlowBorderData(): FlowBorderData {
    let speed: number = borderFlowSpeed();
    let space: number = flowBorderSpace();
    let width: number = flowBorderWidth();

    return {
        speed,
        space,
        width
    };
}

export function borderFlowSpeed(): number {
    let borderSpeed: number = Config.get({
        moduleName: 'base',
        key: 'borderSpeed'
    });

    return (100 - borderSpeed) * 10;
}

export function flowBorderWidth(): number {
    let borderWidth: number = Config.get({
        moduleName: 'base',
        key: 'borderWidth'
    });

    return borderWidth;
}

export function flowBorderSpace(): number {
    let borderSpace: number = Config.get({
        moduleName: 'base',
        key: 'borderSpace'
    });

    return borderSpace * 2;
}
